var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square-button outer",class:_vm.isSub ? 'sub' : 'main',on:{"click":function($event){$event.stopPropagation();return _vm.handleSquareBtnClick.apply(null, arguments)}}},[_c('v-btn',{staticClass:"inner",class:{max_width: _vm.isMaxWidth}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }